var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-profile-view container"},[_c('ProfileViewTile',{staticClass:"mb-4"}),_c('ProfileCards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }